<template>
  <BaseInnerLoading v-if="isLoading" />
  <div v-else-if="isError" class="text-error"
    >Something went wrong</div
  >
  <ol v-else class="space-y-1">
    <li
      v-for="transaction in transactions"
      :key="transaction.id"
    >
      <span
        class="flex w-full flex-row items-center justify-start space-x-2 rounded-lg bg-background px-3 py-1 shadow"
      >
        <div>
          <div class="line-clamp-1 text-sm font-semibold">
            <span class="font-bold text-primary">
              {{ transaction.merchantName }}
            </span>
            {{ transaction.source }}
            <template v-if="transaction.sourceNumber"
              >: #{{ transaction.sourceNumber }}</template
            >
          </div>

          <div class="line-clamp-1 flex items-center">
            <span
              class="mr-1 text-xs text-background-fg/87"
            >
              {{ formatToDate(transaction.createdAt) }}
            </span>
            <span class="text-sm font-semibold">
              {{ formatToTime(transaction.createdAt) }}
            </span>
          </div>
        </div>

        <div class="flex-1">
          <p
            :class="[
              transaction.status === 'successful'
                ? {
                    payment: 'text-background-fg',
                    refund: 'text-error',
                  }[transaction.type]
                : 'text-black/30',
              'line-clamp-1 text-right font-semibold',
            ]"
          >
            <span class="mr-2 text-sm">{{
              getStatusText(transaction)
            }}</span>

            <template v-if="transaction.type === 'refund'"
              >-</template
            >
            {{
              formatToCurrencyString(
                transaction.amountTransactedTotal,
                transaction.currency
              )
            }}
          </p>
        </div>

        <div class="flex w-16 shrink-0 justify-center">
          <PaymentDetailChip
            :payment="getPaymentMethod(transaction)"
          />
        </div>
      </span>
    </li>
  </ol>
</template>

<script setup lang="ts">
import {
  useMerchantGroupLastFiveTransactions,
  type ListMerchantGroupLastFiveTransactionsResponseItem,
} from "@/services/merchantGroup/listMerchantGroupLastFiveTransactions"
import type {
  PaymentDetailCard,
  PaymentDetailCash,
} from "@/services/sharedTypes/invoices"

const { formatToCurrencyString } = useCurrency()
const {
  data: transactions,
  isLoading,
  isError,
} = useMerchantGroupLastFiveTransactions()

const getPaymentMethod = (
  transaction: ListMerchantGroupLastFiveTransactionsResponseItem
): PaymentDetailCard | PaymentDetailCash =>
  transaction.transactionMethod === "pos_card"
    ? {
        transactionMethod: transaction.transactionMethod,
        cardScheme: transaction.cardScheme ?? "",
        cardNumberLast4: transaction.cardNumberLast4 ?? "",
      }
    : {
        transactionMethod: transaction.transactionMethod,
      }

const getStatusText = (
  transaction: ListMerchantGroupLastFiveTransactionsResponseItem
) => {
  return {
    successful: "",
    cancelled: "Cancelled",
    voided: "VOIDED",
    pending: "Pending",
    failed: "Failed",
  }[transaction.status]
}
</script>
